import React from 'react';

// Types
import { UserSuggestion, UserSuggestionType } from 'Shared/types/UserSuggestion.type';

// Hooks
import { useUserSuggestion } from 'Shared/utils/hooks/use-user-suggestion';

// Styles
import './CompletedUserSuggestion.scss';

type Props = {
  userSuggestion: UserSuggestion;
};

const CompletedUserSuggestion = ({ userSuggestion }: Props) => {
  const baseClassName = 'CompletedUserSuggestion';

  const { otherUser } = useUserSuggestion({ userSuggestion });

  const getTitle = () => {
    if (userSuggestion.type === UserSuggestionType.provideKudos)
      return `🙌 \u00A0You helped ${otherUser.firstName || otherUser.email} feel valued `;
    if (userSuggestion.type === UserSuggestionType.goalReminder) return `💪 \u00A0You checked in on your goal`;
    if (userSuggestion.type === UserSuggestionType.feedbackDraftReminder)
      return `🤩 \u00A0You finished ${otherUser.firstName || otherUser.email}'s feedback`;
    if (userSuggestion.type === UserSuggestionType.provideFeedback)
      return `🌱 \u00A0You took action to help ${otherUser.firstName || otherUser.email} grow!`;
    if (userSuggestion.type === UserSuggestionType.prepareForMeeting)
      return `🙌 \u00A0You took action to improve your 1:1 with ${otherUser.firstName || otherUser.email}!`;
    return null;
  };

  const isDismissed = Boolean(userSuggestion.dismissedAt);

  return (
    <div className={`${baseClassName}__item__body`}>
      <p className={`${baseClassName}__item__body__title`}>
        {isDismissed && (
          <span className={`${baseClassName}__item__body__title__dismisssed-label`}>Dismissed:&nbsp;</span>
        )}
        {getTitle()}
      </p>
    </div>
  );
};

export default CompletedUserSuggestion;
